import { SvgIcon } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';

const CircleCrossIcon = (props) => (
  <SvgIcon width="16" height="16" viewBox="0 0 16 16" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.9987 1.33325C4.3168 1.33325 1.33203 4.31802 1.33203 7.99992C1.33203 11.6818 4.3168 14.6666 7.9987 14.6666C11.6806 14.6666 14.6654 11.6818 14.6654 7.99992C14.6654 4.31802 11.6806 1.33325 7.9987 1.33325ZM5.52729 5.52851C5.78764 5.26817 6.20975 5.26817 6.4701 5.52851L7.9987 7.05711L9.52729 5.52851C9.78764 5.26817 10.2098 5.26817 10.4701 5.52851C10.7305 5.78886 10.7305 6.21097 10.4701 6.47132L8.94151 7.99992L10.4701 9.52851C10.7305 9.78886 10.7305 10.211 10.4701 10.4713C10.2098 10.7317 9.78764 10.7317 9.52729 10.4713L7.9987 8.94273L6.4701 10.4713C6.20975 10.7317 5.78764 10.7317 5.52729 10.4713C5.26694 10.211 5.26694 9.78886 5.52729 9.52851L7.05589 7.99992L5.52729 6.47132C5.26694 6.21097 5.26694 5.78886 5.52729 5.52851Z"
      fill={props.sx?.color || '#FF0000'}
    />
    <path
      d="M5.52729 5.52851C5.78764 5.26817 6.20975 5.26817 6.4701 5.52851L7.9987 7.05711L9.52729 5.52851C9.78764 5.26817 10.2098 5.26817 10.4701 5.52851C10.7305 5.78886 10.7305 6.21097 10.4701 6.47132L8.94151 7.99992L10.4701 9.52851C10.7305 9.78886 10.7305 10.211 10.4701 10.4713C10.2098 10.7317 9.78764 10.7317 9.52729 10.4713L7.9987 8.94273L6.4701 10.4713C6.20975 10.7317 5.78764 10.7317 5.52729 10.4713C5.26694 10.211 5.26694 9.78886 5.52729 9.52851L7.05589 7.99992L5.52729 6.47132C5.26694 6.21097 5.26694 5.78886 5.52729 5.52851Z"
      fill={props.sx?.color || '#FFFFFF'}
    />
  </SvgIcon>
);

CircleCrossIcon.propTypes = {
  sx: PropTypes.object,
};

export default CircleCrossIcon;
